import { Dropdown, Col, Row, Space, Typography, Modal, Button, message } from "antd";
import { useState } from "react";
import TestGroupsFormDialog from "../components/bundles-test-groups/TestGroupsFormDialog";
import { Guid } from "guid-typescript";
import { SearchQuery } from "../code/search-query/search-query";
import { getTestGroupsExport } from "../repository/data.repository";
import Loader from "../controls/Loader";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import TestGroupsView from "../components/bundles-test-groups/TestGroupsView";
import { TestGroup } from "../repository/data.default";
import { getProblemMessage } from "../utils/http";

function BundlesTestGroupsPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [testGroupInputMode, setTestGroupInputMode] = useState<
    "add" | "update" | "delete"
  >("add");
  const [testGroupInputOpen, setTestGroupInputOpen] = useState(false);
  const [testGroupInputValues, setTestGroupInputValues] = useState<TestGroup>(
    {} as any,
  );
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const permissions = useSelector(authorizeSelectors.permissions);

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onTestGroupInputOpen(
    mode: "add" | "update" | "delete",
    values?: TestGroup,
  ): void {
    setTestGroupInputMode(mode);
    setTestGroupInputOpen(true);
    setTestGroupInputValues(
      values
        ? {
            uid: values.uid,
            rowVersion: values.rowVersion,
            company: {
              display: values.companyName,
              value: values.companyUid,
            },
            bundle: {
              display: values.bundleName,
              value: values.bundleUid,
            },
            allowedSubmissions: values.allowedSubmissions,
          }
        : ({} as any),
    );
  }

  function onTestGroupInputFinish(): void {
    setTestGroupInputOpen(false);
    setTestGroupInputValues({} as any);
    setTriggerView(Guid.create().toString());
  }

  function onTestGroupInputClose(): void {
    setTestGroupInputOpen(false);
    setTestGroupInputValues({} as any);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading test groups export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getTestGroupsExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => {
        loading.destroy();
      })
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Test Groups
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            disabled={!permissions.can("Bundles", "create")}

            className={`${!permissions.can("Bundles", "create") ? "disabled" : ""}`}
            menu={{
              items: [
                {
                  key: "downloadExport",
                  label: "Export to Excel",
                  disabled: !permissions.can("Bundles", "view"),
                  onClick: onDownloadExport,
                },
              ],
            }}
            onClick={() => onTestGroupInputOpen("add")}
          >
            Add Group
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <TestGroupsView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onTestGroupInputOpen(key as any, record)
          }
          onSearch={onSearch}
        />
      </Col>
      <TestGroupsFormDialog
        key={testGroupInputMode}
        mode={testGroupInputMode}
        open={testGroupInputOpen}
        initialValues={testGroupInputValues}
        onFinish={onTestGroupInputFinish}
        onCancel={onTestGroupInputClose}
      />
      {contextHolder}
    </Col>
  );
}

export default BundlesTestGroupsPage;
